import { render, staticRenderFns } from "./PagesHeader.vue?vue&type=template&id=92abf654&scoped=true"
import script from "./PagesHeader.vue?vue&type=script&lang=js"
export * from "./PagesHeader.vue?vue&type=script&lang=js"
import style0 from "./PagesHeader.vue?vue&type=style&index=0&id=92abf654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92abf654",
  null
  
)

export default component.exports